export default "__VITE_ASSET__C80JDqoa__"